// BASIC EMPTY MODAL 

export const basicModalTemplate = (dialogId) =>`
<dialog class="modal" id="${dialogId}" closedby="any">
    <div class="modal-head">
        <div class="close-button">
            <svg class="icon close"><use xlink:href="#icon-x"></use></svg>
        </div>
    </div>
    <div class="modal-body">
    </div>
</dialog>`;
